import axios from 'axios';
import qs from 'qs';
import Utils from '@/utils/Utils';
import Config from '@/utils/Config';
import store from '@/store';

const isIE = Utils.isIE;

if (isIE()) {
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*.';
    axios.defaults.headers.common.Accept = 'application/json';
    axios.defaults.headers.common['Access-Control-Request-Headers'] = 'accept';
    axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,POST';
    axios.defaults.withCredentials = true;
}

axios.interceptors.response.use(response => response, error => Promise.reject(error));

axios.interceptors.request.use((request) => {
    console.log({ Config })
    const res = request;
    const timestamp = (new Date()).getTime();
    const { userid, kycToken } = (store.getters.currAccount||{});
    const data = Object.assign(
        {
            channel: Config.channel || 'btt',
            timestamp,
            userId: userid,
            userToken: kycToken,
        },
        request.data
    );
    let user = null;
    if (Config.CenterTrade) {
        user = JSON.parse(localStorage.getItem('session')) || {};
    }
    const cmds = ['register', 'login', 'getTokenInfo'];
    if (user && Config.CenterTrade && user.email && !cmds.includes(data.cmd)) {
        data.email = user.email;
        data.userToken = user.token;
        data.userid = user.bttUserid;
    }
    res.data = qs.stringify(data);
    if(request.method !== 'post') res.params = {...data, ...res.params};
    return res;
}, error => Promise.reject(error));
export default axios;



// WEBPACK FOOTER //
// ./src/service/interceptor.js